import {Typography} from '@mui/material';

const LabelText=({row,fieldName,application})=>{
    const fieldProp=row?.[fieldName];
    const color=fieldProp?.ui_color;
    return (
        <Typography color={color} align="left" variant="h6">
            {row[fieldName]?.value}
        </Typography>
    );
}

export default LabelText;
